import userflow from "userflow.js";

import { getUserflowToken, isUserflowActive } from "./config";

/**
 * Element inference attributes Userflow uses to target DOM elements for flows/tooltips.
 * We include data-tour so flows can target elements marked with data-tour="…" in the app.
 * Must be set before userflow.init(). See: https://docs.userflow.com/docs/dev/element-inference
 */
const INFERENCE_ATTRIBUTE_NAMES = ["data-tour"];

if (isUserflowActive) {
  userflow.setInferenceAttributeNames(INFERENCE_ATTRIBUTE_NAMES);
  userflow.setInferenceClassNameFilter(() => false); // This prevents userflow from using css selectors when using the autoselector
  const token = getUserflowToken();
  if (token) {
    userflow.init(token);
  }
}
